import apiClient from './ApiClient';

export const userAuthenticate = (Email, Password) => 
    apiClient.post('/Authenticate', { Email, Password });
